import React, { useState } from 'react';
import HomeNavBar from "../components/HomeNavBar"

import StudentRegisterForm from '../forms/StudentRegisterForm';
import backgroundImg from '../assets/images/background.jpg';




// Content Section Component
const ContentSection = () => {
  return (
    <div style={{
     
      borderRadius: '10px',
      padding: '2rem',
      margin: '1rem 0'
    }}>
      <h1 style={{
        fontSize: '3.5rem',
        fontWeight: 'bold',
        marginBottom: '1rem',
        color: '#fff'
      }}>Welcome to Our Homepage</h1>
      <p style={{
        fontSize: '1.2rem',
        lineHeight: '1.6',
        color: '#fff'
      }}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
      </p>
      <p style={{
        fontSize: '1.2rem',
        lineHeight: '1.6',
        color: '#fff'
      }}>
        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.
      </p>
      <p style={{
        fontSize: '1.2rem',
        lineHeight: '1.6',
        color: '#fff'
      }}>
        Totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
      </p>
    </div>
  );
};

// Main Homepage Component
const Homepage = () => {
  return (
    <div>
      {/* Bootstrap 5 CSS Link */}
      <link 
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css" 
        rel="stylesheet" 
      />
      
      <div style={{ fontFamily: 'Arial, sans-serif' }}>
        {/* Navigation */}
        <HomeNavBar />

        {/* Hero Section */}
        <section style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${backgroundImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: 'calc(100vh - 80px)',
          display: 'flex',
          alignItems: 'center'
        }}>
          <div className="container">
            <div className="row">
              {/* Form Section (1/3) - Left side */}
              <div className="col-lg-4">
                <StudentRegisterForm />
              </div>

              {/* Content Section (2/3) - Right side */}
              <div className="col-lg-8">
                <ContentSection />
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Bootstrap 5 JS Script */}
      <script 
        src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/js/bootstrap.bundle.min.js"
      ></script>
    </div>
  );
};

export default Homepage;